module.exports = __webpack_public_path__ + "static/media/noLogo.45eb4239.svg";